"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTransporter = findTransporter;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
function findTransporter(transporters, { totalWeight, longestDimension, unWrappedDimensions }) {
    if (transporters.length === 1)
        return transporters[0];
    const transporterForTotalConsignmentWeightInGrams = getTransporterFor(transporters, totalWeight, module_logistic_interfaces_1.TransporterRangeUnit.TotalConsignmentWeightInGrams) ||
        getTransporterFor(transporters, totalWeight, module_logistic_interfaces_1.TransporterRangeUnit.WeightInG);
    const transporterForLongestProductDimensionInMillimeters = getTransporterFor(transporters, longestDimension, module_logistic_interfaces_1.TransporterRangeUnit.LongestProductDimensionInMillimeters) ||
        getTransporterFor(transporters, longestDimension, module_logistic_interfaces_1.TransporterRangeUnit.DimensionInMm);
    const transporterForUnWrappedProductDimensionsInMillimeters = getTransporterFor(transporters, unWrappedDimensions, module_logistic_interfaces_1.TransporterRangeUnit.UnWrappedProductDimensionsInMillimeters);
    const appropriateTransporters = [
        transporterForTotalConsignmentWeightInGrams,
        transporterForLongestProductDimensionInMillimeters,
        transporterForUnWrappedProductDimensionsInMillimeters
    ].filter((transporter) => !!transporter);
    if (!appropriateTransporters.length)
        return undefined;
    return findMostAppropriate(appropriateTransporters);
}
function findRangeByUnit(transporter, rangeUnit) {
    var _a;
    return (_a = transporter.ranges) === null || _a === void 0 ? void 0 : _a.find((range) => range.unit === rangeUnit);
}
function getTransporterFor(transporters, rangeValue, rangeUnit) {
    return transporters.find((transporter) => {
        const foundedRange = findRangeByUnit(transporter, rangeUnit);
        return isValueInRange(rangeValue, foundedRange);
    });
}
function findMostAppropriate(transporters) {
    return transporters.reduce((mostAppropriate, transporter) => {
        return getTransporterWeightRangeStart(mostAppropriate) > getTransporterWeightRangeStart(transporter)
            ? mostAppropriate
            : transporter;
    }, transporters[0]);
}
function getTransporterWeightRangeStart(transporter) {
    var _a, _b;
    return (((_a = findRangeByUnit(transporter, module_logistic_interfaces_1.TransporterRangeUnit.TotalConsignmentWeightInGrams)) === null || _a === void 0 ? void 0 : _a.start) ||
        ((_b = findRangeByUnit(transporter, module_logistic_interfaces_1.TransporterRangeUnit.WeightInG)) === null || _b === void 0 ? void 0 : _b.start) ||
        0);
}
function isValueInRange(rangeValue, foundedRange) {
    if (!foundedRange)
        return false;
    if (foundedRange.start <= rangeValue) {
        return foundedRange.end ? foundedRange.end > rangeValue : true;
    }
    return false;
}
